import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';

import { map } from 'rxjs/operators';
import { Actions } from '../../actions';
import {
  CreateAssetSuccess,
  ReplaceAssetSuccess,
  StartAssetUpload,
} from '../action-creators';
import { CREATE_ASSET_SUCCESS, REPLACE_ASSET_SUCCESS } from '../actions';
import { AssetUpload } from '@webapp/types/assets/asset-upload';

export const startUploadEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, CreateAssetSuccess | ReplaceAssetSuccess>(
      CREATE_ASSET_SUCCESS,
      REPLACE_ASSET_SUCCESS
    ),
    map((action) => {
      const upload: AssetUpload = {
        id: action.response.id,
        status: 'uploading',
        filename: action.fileName,
        size: action.size,
        url: action.response.url,
        progress: 0,
        error: undefined,
        trackingId: action.trackingId,
        cancel: action.response.upload.cancel,
      };

      return new StartAssetUpload(upload);
    })
  );
